import axios from 'axios'
import { baseUrl, tokenUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 绑定手机号
export function phoneBind(params) {
  const url = baseUrl + '/phone/bind'
  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '绑定手机号', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}
// 解绑手机号
export function phoneUnbind(params) {
  const url = baseUrl + '/phone/unbind'
  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '解绑手机号', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}
// 获取用户信息
export function getUserInfo() {
  const url = baseUrl + '/user/login/info'

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('个人设置', '获取用户信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 更新用户信息
export function updateUserInfo(params) {
  const url = baseUrl + '/user/login/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('个人设置', '更新用户信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取二维码
export function getQrCode(params) {
  const url = tokenUrl + '/wx/qrcode'

  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '获取绑定微信二维码', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 绑定微信
export function wxBind(params) {
  const url = baseUrl + '/wx/bind'
  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '绑定微信', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 解绑微信
export function wxUnBind() {
  const url = baseUrl + '/wx/unbind'
  return axios({
    method: 'get',
    url: url,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '解绑微信', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 更新密码
export function updatePwd(params) {
  const url = baseUrl + '/user/password/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('个人设置', '更新密码', res)
    }
    return Promise.resolve(res.data)
  })
}

// 保存webhook
export function saveWebHook(params) {
  const url = baseUrl + '/tenant/config/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '保存webhook', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 更新webhook
export function updateWebHook(params) {
  const url = baseUrl + '/tenant/config/update'
  return axios({
    method: 'put',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '保存webhook', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 获取webhook
export function getWebHook() {
  const url = baseUrl + '/tenant/config/find'
  return axios({
    method: 'get',
    url: url,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '获取webhook', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 获取租户直播、实时视频录制配置
export function getTranscribe() {
  const url = baseUrl + '/tenant/transcribe/list'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 更新租户直播、实时视频录制配置
export function updateTranscribe(params) {
  const url = baseUrl + '/tenant/config/update/transcribe'
  return axios({
    method: 'put',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('个人设置', '更新租户配置', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}
